import featuresReducer from './features/features.reducer'
import pagesReducer from './pages/pages.reducer'
import dataReducer from './data/reducer'

export default {
  pages: pagesReducer,
  features: featuresReducer,
  data: dataReducer,
}
